<template>
  <div class="relative">
    <div id="day_picker" @click="isOpen = !isOpen">
      <p v-if="!date" class="text-cebeo_gray">{{ $t('components.chooseADate') }}*</p>
      <p v-if="date">
        {{ this.toddmmyyyy(date) }}
      </p>
      <img src="../../assets/icons/calendar.svg" class="h-6/10"/>
    </div>
    <div v-show="isOpen" id="dropdown_content">
      <vue-cal xsmall hide-view-selector :minDate="new Date()" :selected-date="date"
               today-button
               :locale="$root.$i18n.locale"
               @cell-click="updateDate" :active-view="'month'"
               :disable-views="['years', 'year', 'week','day']"/>
    </div>
  </div>
</template>

<script>
import VueCal from 'vue-cal';
import 'vue-cal/dist/i18n/nl.js';
import 'vue-cal/dist/i18n/fr.js';
import 'vue-cal/dist/vuecal.css';
import dateConversion from '@/mixins/dateConversion';

export default {
  name: 'DayPicker',

  components: {
    VueCal
  },

  mixins: [dateConversion],

  props: {
    date: { required: true }
  },

  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    updateDate(event) {
      this.$emit('update:date', event);
      this.isOpen = false;
    }
  }
};
</script>
<style scoped>
#day_picker {
  height: 50px;
  line-height: 50px;
  @apply bg-cebeo_blue_faded text-left px-10 uppercase flex justify-between items-center shadow-md cursor-pointer;
}

#dropdown_content {
  @apply absolute w-full bg-white z-50;
}
</style>

<style>
.vuecal__cell--selected {
  background-color: var(--cebeo_blue);
}

.vuecal__cell--today {
  background-color: var(--cebeo_blue_faded);
}
</style>
